// Shared kiosk styling + 12x8 grid helpers used by both the editor and the live kiosk.

export function fontStyleToCss(fs) {
  if (!fs) return {};
  return {
    fontFamily: `'${fs.family}', sans-serif`,
    fontWeight: fs.weight || "400",
    fontSize: `${fs.size || 16}px`,
    color: fs.color || "#2A2626",
  };
}

export function buttonStyleToCss(bs) {
  if (!bs) return {};
  const shadowMap = {
    none: "none",
    sm: "0 1px 2px rgba(0,0,0,0.08)",
    md: "0 4px 12px rgba(0,0,0,0.12)",
    lg: "0 10px 25px rgba(0,0,0,0.15)",
    xl: "0 20px 40px rgba(0,0,0,0.20)",
  };
  return {
    backgroundColor: bs.bg_color,
    color: bs.text_color,
    borderRadius: `${bs.border_radius}px`,
    boxShadow: shadowMap[bs.shadow] || shadowMap.lg,
    padding: `${bs.padding_y}px ${bs.padding_x}px`,
    fontFamily: `'${bs.font?.family || "Montserrat"}', sans-serif`,
    fontWeight: bs.font?.weight || "700",
    fontSize: `${bs.font?.size || 22}px`,
  };
}

export const GRID_COLS = 12;
export const GRID_ROWS = 8;

// Build the list of individually-placeable widgets from a kiosk config.
export function deriveWidgets(cfg) {
  const widgets = [
    { key: "logo", kind: "logo", label: "Logo" },
    { key: "brand", kind: "brand", label: "Church Name" },
    { key: "clock", kind: "clock", label: "Date / Time" },
    { key: "featured", kind: "featured", label: "Featured Event" },
  ];
  (cfg?.buttons || []).forEach((btn, idx) => {
    widgets.push({ key: btn.id || `btn_${idx}`, kind: "button", label: btn.label || `Button ${idx + 1}`, btn, idx });
  });
  return widgets;
}

function defaultPos(wd) {
  switch (wd.kind) {
    case "logo": return { x: 0, y: 0, w: 2, h: 1 };
    case "brand": return { x: 2, y: 0, w: 6, h: 1 };
    case "clock": return { x: 8, y: 0, w: 4, h: 1 };
    case "featured": return { x: 0, y: 1, w: 7, h: 6 };
    case "button": return { x: 7, y: Math.min(1 + (wd.idx || 0), GRID_ROWS - 1), w: 5, h: 1 };
    default: return { x: 0, y: GRID_ROWS - 1, w: 3, h: 1 };
  }
}

// Merge saved grid positions with the current widget set. Unknown saved keys are
// dropped; new widgets (e.g. a freshly added button) get a sensible default slot.
export function reconcileGrid(cfg) {
  const widgets = deriveWidgets(cfg);
  const saved = cfg?.grid_layout?.items || [];
  const map = {};
  saved.forEach((it) => { map[it.i] = it; });
  const items = widgets.map((wd) => {
    const s = map[wd.key];
    const d = defaultPos(wd);
    return {
      i: wd.key,
      x: s?.x ?? d.x,
      y: s?.y ?? d.y,
      w: s?.w ?? d.w,
      h: s?.h ?? d.h,
    };
  });
  return { items };
}
